import { type OfferV11 } from '@redteclab/api/clients/bully'

import { productAccessorOfferHasSellerPromotion } from './productAccessorOfferHasSellerPromotion'

export const productAccessorSellerPromotionExistsForOtherSeller = (
  currentSellerId: string,
  offers: OfferV11[] | undefined,
): boolean => {
  if (!offers) {
    return false
  }

  return offers
    .filter(productAccessorOfferHasSellerPromotion)
    .map((offer) => offer.seller?.sellerId)
    .some((id) => id !== currentSellerId)
}
